import Default from './Themes/Default';

const BundleCard = () => <Default />;

export default BundleCard;
